import { z } from 'zod';
import type { ReportStatus } from './enums';

/**
 * Global search, backing the command palette.
 *
 * Two characters minimum: a single character matches most of the database and
 * the result is noise, not a shortcut.
 */
export const globalSearchQuerySchema = z.object({
  q: z.string().trim().min(2, 'Type at least two characters'),
  limit: z.coerce.number().int().min(1).max(10).default(5),
});
export type GlobalSearchQuery = z.infer<typeof globalSearchQuerySchema>;

interface SearchPatientHit {
  id: number;
  name: string;
  pin_no: string;
  mr_no: string;
  phone_number: string;
}

interface SearchReportHit {
  id: number;
  name: string;
  report_status: ReportStatus;
  patient: { id: number; name: string; pin_no: string };
}

interface SearchLabTestHit {
  id: number;
  name: string;
  code: string;
  price: number;
}

/**
 * Grouped rather than a flat ranked list: an operator typing a PIN wants the
 * patient, and one typing "CBC" wants the test. Keeping the groups separate
 * means neither has to out-rank the other.
 */
export interface GlobalSearchResults {
  patients: SearchPatientHit[];
  reports: SearchReportHit[];
  lab_tests: SearchLabTestHit[];
}
